import { cloudSvc } from "../../services";
import { initializeActions } from "@fpos/react-navigation";


export const testStoreName = "testStore";

export const actions = initializeActions( testStoreName, {
    UPDATE_INMYSTATE: "",
    UPDATE_CONTENT: ""
});

export const getInitialData = () => async (dispatch) => {
    
};
